import deleteTrashCan from "assets/img/delete-trash-can.svg";
import Button from "components/Button";
import { Card, CardList } from "components/Card";
import CSVDownload from "components/CSVDownload";
import CSVDownload3 from "components/CSVDownload3";
import Icon from "components/Icon";
import Table from "components/Table";
import Config from "config";
import { RouteProps } from "containers/App";
import CreateBreadcrumb from "containers/CreateBreadcrumb";
import FileUpload from "containers/FileUpload";
import ManageDataPreview from "containers/ManageDataPreview";
import { Store } from "interfaces/store";
import React from "react";
import Popover from "react-popover";
import { connect, ConnectedProps } from "react-redux";
import { State } from "state";
import { createStoreInfo, deleteStoreById, fetchStores, updateStoreInfo } from "state/stores";
import { buildExportFilename, getTemplateHeaders } from "utils/helpers";
import Modal from "../components/LightThemeModal";
import doucments from "../assets/img/document.svg";
import { LightThemeTable } from "../components/LightThemeTable";
import ApiTable from "components/ApiTable";
import ChainFilter from "./ChainFilter";
import FileEditorModal from "components/FileEditorModal";
import Loader from "components/Loader";
import { SeverityLevel, ToastService } from "../services/toastService";
import { Country, State as StateData, City } from "country-state-city";
import { ICountry, IState, ICity } from "country-state-city";
import LocationDropdown from "components/LocationDropdown";

type ManageStoresProps = PropsFromRedux & RouteProps;

interface ManageStoresState {
  showModal: boolean;
  retail_store_num: string;
  name: string;
  address_line1: string;
  address_line2: string;
  city: string;
  storeState: string;
  country: string;
  zip: string;
  status: string;
  cluster_store_group: string;
  ad_zone: string;
  abinbev_wholesaler: string;
  coors_wholesaler: string;
  miller_wholesaler: string;
  third_party_wholesaler: string;
  cid: string;
  editingStore: any;
  showErrors: boolean;
  showWarningModal: boolean;
  statusMessage: string;
  tableData: Store[];
  chainId: number;
  deletePopoverOpenId: number | null;
  isContinuebtnDisplay: boolean;
  fileEditorOpen: boolean;
  fileEditorFile: File | null;
  fileEditorError: string | null;
  isLoading?: boolean;
  isAwaitingCreation?: boolean;
  selectedCountryCode: string | null;
  selectedStateCode: string | null;
  // API pagination state
  page: number;
  size: number;
  sort: string;
  search_name: string;
  search_retail_store_num: string;
  search_state: string;
  search_address_line1: string;
}

interface CountryOption {
  value: string;
  label: string;
  code: string;
}

interface StateOption {
  value: string;
  label: string;
  code: string;
}

interface CityOption {
  value: string;
  label: string;
}

interface ComponentState {
  selectedCountryCode: string | null;
  selectedStateCode: string | null;
}

const styles = {
  container: { background: "#fff", padding: 10, borderRadius: 10 },
  header: { fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: 14, marginBottom: 15 },
  button: (bg: string, color: string, border: string = "none") => ({
    padding: "5px 15px",
    border,
    borderRadius: 4,
    backgroundColor: bg,
    color,
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
  }),
  input: { width: "100%", padding: 8, borderRadius: 16, border: "1px solid #ccc", fontSize: 12 },
  modalFooter: { display: "flex", justifyContent: "flex-end", marginTop: 15 },
  confirmFooter: { display: "flex", justifyContent: "center", gap: 20 },
};
let label2 = "Upload New Stores";
class ManageStores extends React.Component<ManageStoresProps, ManageStoresState, ComponentState> {
  public state = {
    showModal: false,
    retail_store_num: "",
    name: "",
    address_line1: "",
    address_line2: "",
    city: "",
    storeState: "",
    country: "",
    zip: "",
    status: "",
    cluster_store_group: "",
    ad_zone: "",
    abinbev_wholesaler: "",
    coors_wholesaler: "",
    miller_wholesaler: "",
    third_party_wholesaler: "",
    cid: "",
    editingStore: { id: -1 },
    showErrors: false,
    showWarningModal: false,
    statusMessage: "",
    tableData: [],
    chainId: -1,
    chainName: "",
    deletePopoverOpenId: null,
    isContinuebtnDisplay: false,
    fileEditorOpen: false,
    fileEditorFile: null,
    fileEditorError: null,
    isLoading: false,
    isAwaitingCreation: false,
    selectedCountryCode: null,
    selectedStateCode: null,
    // API pagination state
    page: 0,
    size: 100,
    sort: "updated_at.desc",
    search_name: "",
    search_retail_store_num: "",
    search_state: "",
    search_address_line1: "",
  };

  protected CSV_HEADERS = [
    { label: "Chain Name", key: "chain_name" },
    { label: "Retail Store Number", key: "retail_store_num" },
    { label: "Store Name", key: "name" },
    { label: "Address Line 1", key: "address_line1" },
    { label: "Address Line 2", key: "address_line2" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Country", key: "country" },
    { label: "Zip Code", key: "zip" },
    { label: "Status", key: "status" },
    { label: "Cluster Store Group", key: "cluster_store_group" },
    { label: "Ad Zone", key: "ad_zone" },
    { label: "ABInBev Wholesaler", key: "abinbev_wholesaler" },
    { label: "Constellation Wholesaler", key: "coors_wholesaler" },
    { label: "Molson Coors Wholesaler", key: "miller_wholesaler" },
    { label: "Third Party Wholesaler", key: "third_party_wholesaler" },
    { label: "Catalyst ID", key: "cid" },
  ];

  private countriesCache: CountryOption[] | null = null;
  private statesCache: Map<string, StateOption[]> = new Map();
  private citiesCache: Map<string, CityOption[]> = new Map();

  protected MAX_DELETE_COLUMN_WIDTH = 100;

  protected POPOVER_TRANSITION_MS = 100;

  // Get all countries with memoization
  getAllCountries = (): CountryOption[] => {
    if (!this.countriesCache) {
      this.countriesCache = Country.getAllCountries().map((country: ICountry) => ({
        value: country.isoCode, // Changed from country.name to country.isoCode
        label: country.name,
        code: country.isoCode,
      }));
    }
    return this.countriesCache;
  };

  getStatesForCountry = (countryCode: string): StateOption[] => {
    if (!countryCode) return [];

    if (this.statesCache.has(countryCode)) {
      return this.statesCache.get(countryCode)!;
    }

    const states = StateData.getStatesOfCountry(countryCode).map((state: IState) => ({
      value: state.isoCode, // Changed from state.name to state.isoCode
      label: state.name,
      code: state.isoCode,
    }));

    this.statesCache.set(countryCode, states);
    return states;
  };

  // Get cities for state with memoization
  getCitiesForState = (countryCode: string, stateCode: string): CityOption[] => {
    if (!countryCode || !stateCode) return [];

    const cacheKey = `${countryCode}-${stateCode}`;

    // Check cache first
    if (this.citiesCache.has(cacheKey)) {
      return this.citiesCache.get(cacheKey)!;
    }

    const cities = City.getCitiesOfState(countryCode, stateCode).map((city: ICity) => ({
      value: city.name,
      label: city.name,
    }));

    // Cache the result
    this.citiesCache.set(cacheKey, cities);
    return cities;
  };

  // Handler for country selection
  handleCountryChange = (value: string, code?: string) => {
    // value is already the country code (e.g., "US")
    this.setState({
      country: value, // Storing the code directly
      selectedCountryCode: value, // Use value instead of code
      selectedStateCode: null,
      storeState: "",
      city: "",
    });
  };

  handleStateChange = (value: string, code?: string) => {
    const { selectedCountryCode } = this.state;
    if (!selectedCountryCode) return;

    // value is already the state code (e.g., "OK")
    this.setState({
      storeState: value, // Storing the code directly
      selectedStateCode: value, // Use value instead of code
      city: "",
    });
  };
  // Handler for city selection
  handleCityChange = (value: string) => {
    this.setState({
      city: value,
    });
  };

  public updateTableData(id: number = this.state.chainId) {
    this.setState({ chainId: id });
    const { size, sort, search_name, search_retail_store_num, search_state, search_address_line1 } = this.state;
    this.props.fetchStores({
      chainId: id,
      page: 0,
      size,
      sort,
      ...(search_name ? { name: search_name } : {}),
      ...(search_retail_store_num ? { retail_store_num: search_retail_store_num } : {}),
      ...(search_state ? { state: search_state } : {}),
      ...(search_address_line1 ? { address_line1: search_address_line1 } : {}),
    });
  }

  public componentDidUpdate(prevProps: ManageStoresProps) {
    if (prevProps.loading !== this.props.loading && !this.props.loading) {
      this.setState({ isLoading: false });
    }
  }

  public componentDidMount() {
    // Do not fetch stores until chain is selected.
  }

  public toggleDeletePopoverOpenId(storeId: number, storeName: string) {
    this.setState({
      deletePopoverOpenId: storeId,
      isContinuebtnDisplay: true,
      showWarningModal: true,
      statusMessage: `Are you sure you want to delete ${storeName}?`,
    });
  }

  public handleDelete(storeId: any) {
    this.setState({ isAwaitingCreation: true });
    this.props.deleteStore(storeId).then(() => {
      ToastService.getInstance().publishToast(
        {
          identifier: "success-operation",
          title: "Success",
          message: "Store deleted successfully!",
        },
        SeverityLevel.SUCCESS,
        { autoClose: 3000 }
      );
      this.setState({
        isContinuebtnDisplay: false,
        showWarningModal: false,
        statusMessage: "",
        isAwaitingCreation: false,
      });
      this.reloadCurrentPage();
    });
  }

  handleSaveNew = async () => {
    const {
      retail_store_num,
      name,
      address_line1,
      city,
      storeState,
      zip,
      address_line2,
      country,
      status,
      cluster_store_group,
      ad_zone,
      abinbev_wholesaler,
      coors_wholesaler,
      miller_wholesaler,
      third_party_wholesaler,
      cid,
      chainId,
      editingStore,
    } = this.state;

    this.setState({
      isAwaitingCreation: true,
      isLoading: true,
    });

    if (editingStore && editingStore.id >= 0) {
      this.props
        .updateStoreInfo(editingStore.id, {
          retail_store_num,
          name,
          address_line1,
          city,
          storeState,
          zip,
          address_line2,
          country,
          status,
          cluster_store_group,
          ad_zone,
          abinbev_wholesaler,
          coors_wholesaler,
          miller_wholesaler,
          third_party_wholesaler,
          cid,
          chain_id: chainId,
        })
        .then(() => {
          if (this.props.errorMessage === 409) {
            let errorMessage =
              this.props.errorMessage === 409
                ? "Retail Store Number already exists in this chain"
                : "An error occurred.";
            this.setState({ showModal: true });
            this.setState({ showWarningModal: true, statusMessage: errorMessage });
          } else {
            this.setState({
              isAwaitingCreation: false,
              showModal: false,
            });
            this.reloadCurrentPage();
            this.resetForm();
          }
        });
    } else {
      this.props
        .createStoreInfo({
          retail_store_num,
          name,
          address_line1,
          city,
          storeState,
          zip,
          address_line2,
          country,
          status,
          cluster_store_group,
          ad_zone,
          abinbev_wholesaler,
          coors_wholesaler,
          miller_wholesaler,
          third_party_wholesaler,
          cid,
          chain_id: chainId,
        })
        .then(() => {
          if (this.props.errorMessage === 409) {
            let errorMessage =
              this.props.errorMessage === 409
                ? "Retail Store Number already exists in this chain"
                : "An error occurred.";
            this.setState({ showModal: true });
            this.setState({ showWarningModal: true, statusMessage: errorMessage });
          } else {
            this.setState({
              isAwaitingCreation: false,
              showModal: false,
            });
            this.reloadCurrentPage();
            this.resetForm();
          }
        })
        .catch((error) => {
          console.log("In the error=>", error);
        });
    }
  };

  reloadCurrentPage = () => {
    const {
      chainId,
      page,
      size,
      sort,
      search_name,
      search_retail_store_num,
      search_state,
      search_address_line1,
    } = this.state;
    this.props.fetchStores({
      chainId,
      page,
      size,
      sort,
      ...(search_name ? { name: search_name } : {}),
      ...(search_retail_store_num ? { retail_store_num: search_retail_store_num } : {}),
      ...(search_state ? { state: search_state } : {}),
      ...(search_address_line1 ? { address_line1: search_address_line1 } : {}),
    });
  };

  checkChainId = (): boolean => {
    const { chainId } = this.state;
    return chainId > 0;
  };

  handleCreateNew = () => {
    if (!this.checkChainId()) {
      return this.setState({ showWarningModal: true, statusMessage: "Please select the chain." });
    }
    this.setState({ showModal: true, editingStore: { id: -1 } }, this.resetForm);
  };

  resetForm = () =>
    this.setState({
      retail_store_num: "",
      name: "",
      address_line1: "",
      address_line2: "",
      city: "",
      storeState: "",
      country: "",
      zip: "",
      status: "",
      cluster_store_group: "",
      ad_zone: "",
      abinbev_wholesaler: "",
      coors_wholesaler: "",
      miller_wholesaler: "",
      third_party_wholesaler: "",
      cid: "",
      editingStore: { id: -1 },
      selectedCountryCode: null,
      selectedStateCode: null,
    });

  handleInputChange =
    (field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      this.setState({ [field]: e.target.value } as any);
    };

  handleEdit = (id: number) => {
    this.resetForm();
    const store = this.props.stores.find((c) => c.id === id);
    if (!store) return;

    // store.country and store.state are already codes
    this.setState({
      editingStore: { id: store.id },
      retail_store_num: store.retail_store_num,
      name: store.name,
      address_line1: store?.address_line1 || "",
      address_line2: store.address_line2 || "",
      city: store.city || "",
      storeState: store.state || "", // Already a code
      zip: store.zip || "",
      country: store.country || "", // Already a code
      selectedCountryCode: store.country || null, // Use store.country directly
      selectedStateCode: store.state || null, // Use store.state directly
      cluster_store_group: store.cluster_store_group || "",
      ad_zone: store.ad_zone || "",
      abinbev_wholesaler: store.abinbev_wholesaler || "",
      coors_wholesaler: store.coors_wholesaler || "",
      miller_wholesaler: store.miller_wholesaler || "",
      third_party_wholesaler: store.third_party_wholesaler || "",
      cid: store.cid || "",
      showModal: true,
    });
  };

  public handleUploadError = (error: any, uploadedFile: File) => {
    // Extract error message from different possible error formats

    console.log("handleUploadError triggers", error);

    const responseErrors = error?.response?.data?.errors;
    const normalizedErrors = Array.isArray(responseErrors)
      ? responseErrors
        .reduce((acc: any[], entry: any) => acc.concat(Array.isArray(entry) ? entry : [entry]), [])
        .filter((entry: any) => typeof entry === "string" && entry.trim())
      : [];

    const errorMessage =
      (normalizedErrors.length > 0 ? normalizedErrors.join(" | ") : null) ||
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Upload failed. Please review and correct the file.";

    this.setState({
      fileEditorOpen: true,
      fileEditorFile: uploadedFile,
      fileEditorError: errorMessage,
    });
  };

  public handleFileEditorClose = () => {
    this.setState({
      fileEditorOpen: false,
      fileEditorFile: null,
      fileEditorError: null,
    });
  };

  public handleFileEditorSuccess = async () => {
    this.reloadCurrentPage();
    this.handleFileEditorClose();
  };

  public render() {
    const {
      showModal,
      editingStore,
      showErrors,
      retail_store_num,
      name,
      address_line1,
      city,
      storeState,
      zip,
      address_line2,
      country,
      status,
      cluster_store_group,
      ad_zone,
      abinbev_wholesaler,
      coors_wholesaler,
      miller_wholesaler,
      third_party_wholesaler,
      cid,
      fileEditorOpen,
      fileEditorFile,
      fileEditorError,
      isLoading,
      isAwaitingCreation,
      selectedCountryCode,
      selectedStateCode,
    } = this.state;

    const tableData = this.state.chainId === -1 ? [] : this.props.stores ?? [];
    const countries = this.getAllCountries();
    // country already contains the code, so use it directly
    const states = country ? this.getStatesForCountry(country) : [];
    const cities = country && storeState ? this.getCitiesForState(country, storeState) : [];

    const columns = [
      {
        field: "retail_store_num",
        header: "Store No",
        sortable: true,
        searchable: true,
      },
      { field: "name", header: "Store Name", sortable: true, searchable: true },
      { field: "address_line1", header: "Address", sortable: false, searchable: true },
      { field: "state", header: "State", sortable: true, searchable: true },
      {
        field: "actions",
        header: "",
        formatter: (_: any, row: Store) => (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 30 }}>
            <button
              onClick={() => this.handleEdit(row.id)}
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              <img src={require("../assets/img/Edit.png")} alt="Edit" />
            </button>
            <button
              onClick={() => this.toggleDeletePopoverOpenId(row.id, row?.name)}
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              <img src={require("../assets/img/Delete.png")} alt="Delete" />
            </button>
          </div>
        ),
      },
    ];

    return (
      <section className="manage-data-container">
        <CreateBreadcrumb
          crumbs={{
            crumbs: [
              {
                to: "/manage-all-data",
                crumb: "VIEW ALL DATA",
                dataQa: "view-all-data-link",
              },
            ],
          }}
        />
        <div className="manage-data-body">
          <div className="upload-section-3">
            <h4>Upload / Update Store Data</h4>
            <div>
              <CSVDownload
                data={[]}
                headers={getTemplateHeaders(label2)}
                filename={buildExportFilename("csv", `${label2}-template`)}
              >
                <div className="file-upload-header">Download CSV Template</div>
              </CSVDownload>
            </div>
            <FileUpload
              prefix={"STORES"}
              url={`${Config.API_SERVICE_URL}/api/stores`}
              label={""}
              dataQa={"manage-stores-file-upload"}
              accept={".csv,text/csv"}
              afterUploadFunction={() => this.reloadCurrentPage()}
              onUploadError={this.handleUploadError}
            />
          </div>
          <CardList>
            <Card>
              <ManageDataPreview prefix={"STORES"} />
            </Card>
          </CardList>
          <div className="manage-data-table-controls" data-qa="chain-dropdown" style={{flexWrap: "wrap", gap: "16px"}}>
            <div style={{ pointerEvents: isLoading ? "none" : "auto", opacity: isLoading ? 0.5 : 1 }}>
              <ChainFilter
                onChange={({ id }) => {
                  this.setState({ chainId: id, page: 0 });
                  this.props.fetchStores({
                    chainId: id,
                    page: 0,
                    size: this.state.size,
                    sort: this.state.sort,
                  });
                }}
                isSearchable
              />
            </div>
            <div className="action-btns" style={{flexWrap: "wrap"}}>
              <div>
                <CSVDownload3
                  data={tableData}
                  headers={this.CSV_HEADERS}
                  filename={buildExportFilename("csv", "stores")}
                  disabled={tableData.length === 0}
                ></CSVDownload3>
              </div>
              <button
                className="primary-button"
                onClick={this.handleCreateNew}
              >
                Create Store
              </button>
            </div>
          </div>
          <CardList>
            <Card>
              <div style={{ margin: "1%" }}>
                {this.state.chainId === -1 ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: 220,
                      color: "#6B7280",
                      fontWeight: 600,
                      fontSize: 22,
                      border: "1px solid #f1f1f1",
                      borderRadius: 8,
                      background: "#fff",
                    }}
                  >
                    Select Chain to View Store Data
                  </div>
                ) : (
                  <ApiTable
                    columns={columns}
                    data={tableData}
                    total={this.props.totalCount ?? 0}
                    loading={this.props.loading}
                    page={(this.props.currentPage ?? 0) + 1}
                    pageSize={this.state.size}
                    pageSizeOptions={[50, 100, 200]}
                    onSearch={(field: string, value: string) => {
                      const searchFieldMap: Record<string, string> = {
                        retail_store_num: "search_retail_store_num",
                        name: "search_name",
                        state: "search_state",
                        address_line1: "search_address_line1",
                      };
                      const stateKey = searchFieldMap[field] || field;
                      this.setState({ [stateKey]: value, page: 0 } as any, () => {
                        const {
                          chainId,
                          size,
                          sort,
                          search_name,
                          search_retail_store_num,
                          search_state,
                          search_address_line1,
                        } = this.state;
                        this.props.fetchStores({
                          chainId,
                          page: 0,
                          size,
                          sort,
                          ...(search_name ? { name: search_name } : {}),
                          ...(search_retail_store_num ? { retail_store_num: search_retail_store_num } : {}),
                          ...(search_state ? { state: search_state } : {}),
                          ...(search_address_line1 ? { address_line1: search_address_line1 } : {}),
                        });
                      });
                    }}
                    onSort={(field: string, order: "asc" | "desc") => {
                      const sortParam = `${field}.${order}`;
                      this.setState({ sort: sortParam, page: 0 }, () => {
                        const {
                          chainId,
                          size,
                          search_name,
                          search_retail_store_num,
                          search_state,
                          search_address_line1,
                        } = this.state;
                        this.props.fetchStores({
                          chainId,
                          page: 0,
                          size,
                          sort: sortParam,
                          ...(search_name ? { name: search_name } : {}),
                          ...(search_retail_store_num ? { retail_store_num: search_retail_store_num } : {}),
                          ...(search_state ? { state: search_state } : {}),
                          ...(search_address_line1 ? { address_line1: search_address_line1 } : {}),
                        });
                      });
                    }}
                    onPageChange={(page1Based: number, size: number) => {
                      const apiPage = Math.max(0, page1Based - 1);
                      this.setState({ page: apiPage, size }, () => {
                        const {
                          chainId,
                          sort,
                          search_name,
                          search_retail_store_num,
                          search_state,
                          search_address_line1,
                        } = this.state;
                        this.props.fetchStores({
                          chainId,
                          page: apiPage,
                          size,
                          sort,
                          ...(search_name ? { name: search_name } : {}),
                          ...(search_retail_store_num ? { retail_store_num: search_retail_store_num } : {}),
                          ...(search_state ? { state: search_state } : {}),
                          ...(search_address_line1 ? { address_line1: search_address_line1 } : {}),
                        });
                      });
                    }}
                  />
                )}
              </div>
            </Card>
          </CardList>
          <div>
            <Modal
              show={showModal}
              onClose={() => this.setState({ showModal: false, showErrors: false })}
              title={editingStore && editingStore["id"] >= 0 ? "Edit Store" : "Create Store"}
              width="800px"
              closeOnBackdropClick={false}
              footer={
                <div style={styles.modalFooter}>
                  <div style={{ display: "flex" }}>
                    <div style={{ display: "flex", marginRight: "5px" }}>
                      {isAwaitingCreation && <Loader height={20} width={20} custom={true}></Loader>}
                    </div>
                    <button
                      onClick={() => {
                        const isValid =
                          retail_store_num.trim() &&
                          name.trim() &&
                          address_line1.trim() &&
                          city.trim() &&
                          storeState.trim() &&
                          zip &&
                          /^\d{5}$/.test(zip);

                        if (!isValid) {
                          this.setState({ showErrors: true });
                          return;
                        }
                        this.setState({ showErrors: false }, () => {
                          this.handleSaveNew();
                        });
                      }}
                      style={{
                        padding: "6px 12px",
                        borderRadius: 4,
                        background: "#E5B42F",
                        color: "#fff",
                        border: "none",
                        fontSize: 12,
                        fontWeight: 600,
                        cursor: "pointer",
                        minWidth: "72px",
                        //marginLeft: "5px",
                      }}
                    >
                      {!isAwaitingCreation ? "Submit" : "Submitting"}
                    </button>
                  </div>
                </div>
              }
            >
              <div style={{ display: "flex", gap: 20, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>
                    Retail Store Number <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={retail_store_num}
                    onChange={this.handleInputChange("retail_store_num")}
                    placeholder="Enter Retail Store Number"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background:
                        this.state.editingStore && this.state.editingStore["id"] >= 0
                          ? "#f0f0f0"
                          : this.state.showErrors && !retail_store_num
                          ? "#ffe6e6"
                          : "#fff",
                    }}
                    disabled={editingStore && editingStore["id"] >= 0 ? true : false}
                  />
                  {this.state.showErrors && !retail_store_num && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <label>
                    Store Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={name}
                    onChange={this.handleInputChange("name")}
                    placeholder="Enter Store Name"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: this.state.showErrors && !name ? "#ffe6e6" : "#fff",
                    }}
                  />
                  {this.state.showErrors && !name && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <label>
                    Address Line1 <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={address_line1}
                    onChange={this.handleInputChange("address_line1")}
                    placeholder="Enter Address Line1"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: this.state.showErrors && !address_line1 ? "#ffe6e6" : "#fff",
                    }}
                  />
                  {this.state.showErrors && !address_line1 && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <label>Address Line2</label>
                  <input
                    type="text"
                    value={address_line2}
                    onChange={this.handleInputChange("address_line2")}
                    placeholder="Enter Address Line2"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", gap: 20, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <div>
                    <LocationDropdown
                      label="Country"
                      value={country}
                      options={countries}
                      onChange={this.handleCountryChange}
                      placeholder="Select Country"
                      disabled={isAwaitingCreation}
                    />
                  </div>
                </div>

                <div style={{ flex: 1 }}>
                  <div>
                    <LocationDropdown
                      label="State"
                      value={storeState}
                      options={states}
                      onChange={this.handleStateChange}
                      placeholder="Select State"
                      required={true}
                      disabled={isAwaitingCreation || !selectedCountryCode}
                    />
                    {!selectedCountryCode && !isAwaitingCreation && (
                      <div style={{ fontSize: 8, color: "#6b7280", marginTop: 2 }}>
                        Select country to enable state.
                      </div>
                    )}
                  </div>
                </div>

                <div style={{ flex: 1 }}>
                  <div>
                    <LocationDropdown
                      label="City"
                      value={city}
                      options={cities}
                      onChange={this.handleCityChange}
                      placeholder="Select City"
                      required={true}
                      disabled={isAwaitingCreation || !selectedStateCode}
                    />
                    {!selectedStateCode && !isAwaitingCreation && (
                      <div style={{ fontSize: 8, color: "#6b7280", marginTop: 2 }}>
                        Select state to enable city.
                      </div>
                    )}
                  </div>
                </div>
                {/* <div style={{ flex: 1 }}>
                  <label>
                    City <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={city}
                    onChange={this.handleInputChange("city")}
                    placeholder="Enter City"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: this.state.showErrors && !city ? "#ffe6e6" : "#fff",
                    }}
                  />
                  {this.state.showErrors && !city && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <label>
                    State <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={storeState}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase(); // Optional: auto-uppercase (e.g., "CA")
                      // ✅ Allow only letters (A–Z) and restrict to max 2 characters
                      if (/^[A-Za-z]{0,2}$/.test(value)) {
                        this.setState({ storeState: value });
                      }
                    }}
                    placeholder="Enter State"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: this.state.showErrors && !storeState ? "#ffe6e6" : "#fff",
                    }}
                  />
                  {this.state.showErrors && !storeState && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <label>Country</label>
                  <input
                    type="text"
                    value={country}
                    onChange={this.handleInputChange("country")}
                    placeholder="Enter Country"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div> */}

                <div style={{ flex: 1 }}>
                  <label>
                    Zip Code <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={zip}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,5}$/.test(value)) {
                        this.handleInputChange("zip")(e);
                      }
                    }}
                    placeholder="Enter Zip Code"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background:
                        this.state.showErrors && (!zip || !/^\d{5}$/.test(zip))
                          ? "#ffe6e6"
                          : "#fff",
                    }}
                  />
                  {this.state.showErrors && !zip && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                  {this.state.showErrors && zip && !/^\d{5}$/.test(zip) && (
                    <span style={{ color: "red", fontSize: 12 }}>Zip code must be 5 digits.</span>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", gap: 18, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>Status</label>
                  <input
                    type="text"
                    value={status}
                    onChange={this.handleInputChange("status")}
                    placeholder="Enter Status"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label>Cluster Store Group</label>
                  <input
                    type="text"
                    value={cluster_store_group}
                    onChange={this.handleInputChange("cluster_store_group")}
                    placeholder="Enter Cluster Group"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label>Ad Zone</label>
                  <input
                    type="text"
                    value={ad_zone}
                    onChange={this.handleInputChange("ad_zone")}
                    placeholder="Enter Ad Zone"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label>ABInBev Wholesaler</label>
                  <input
                    type="text"
                    value={abinbev_wholesaler}
                    onChange={this.handleInputChange("abinbev_wholesaler")}
                    placeholder="Enter ABInBev Wholesaler"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", gap: 18, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>Molson Coors Wholesaler</label>
                  <input
                    type="text"
                    value={miller_wholesaler}
                    onChange={this.handleInputChange("miller_wholesaler")}
                    placeholder="Enter Molson Coors Wholesaler"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label>Constellation Wholesaler</label>
                  <input
                    type="text"
                    value={coors_wholesaler}
                    onChange={this.handleInputChange("coors_wholesaler")}
                    placeholder="Enter Constellation Wholesaler"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label>Third Party Wholesaler</label>
                  <input
                    type="text"
                    value={third_party_wholesaler}
                    onChange={this.handleInputChange("third_party_wholesaler")}
                    placeholder="Enter Third Party Wholesaler"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label>Catalyst ID</label>
                  <input
                    type="number"
                    value={cid}
                    onChange={this.handleInputChange("cid")}
                    placeholder="Enter Catalyst ID"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
              </div>
            </Modal>
          </div>
          <div>
            <Modal
              show={this.state.showWarningModal}
              onClose={() => this.setState({ showWarningModal: false })}
              title=""
              width="400px"
              footer={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                    paddingTop: 10,
                  }}
                >
                  <div style={{ width: "7%", paddingTop: "3px" }}>
                    {isAwaitingCreation && <Loader height={20} width={20} custom={true}></Loader>}
                  </div>
                  {!this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() => this.setState({ showWarningModal: false })}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      OK
                    </button>
                  )}

                  {this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() => this.setState({ showWarningModal: false })}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      Cancel
                    </button>
                  )}

                  {this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() =>
                        this.setState({}, () => this.handleDelete(this.state.deletePopoverOpenId))
                      }
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                      disabled={isAwaitingCreation}
                    >
                      Yes, Continue
                    </button>
                  )}
                </div>
              }
            >
              <p style={{ marginBottom: 20, color: "#555", fontSize: 12 }}>
                <strong>{this.state.statusMessage}</strong>
              </p>
            </Modal>
          </div>
        </div>

        <FileEditorModal
          isOpen={fileEditorOpen}
          file={fileEditorFile}
          error={fileEditorError}
          prefix="STORES"
          config={{
            prefix: "STORES",
            url: `${Config.API_SERVICE_URL}/api/stores`,
            onUploadSuccess: this.handleFileEditorSuccess,
          }}
          onClose={this.handleFileEditorClose}
        />
      </section>
    );
  }
}

const connecter = connect(
  (state: State) => ({
    stores: state.stores.content?.data,
    savedData: state.stores.saveData,
    errorMessage: state.stores.errorMessage,
    loading: state.stores.loading,
    totalCount: state.stores.totalCount,
    currentPage: state.stores.currentPage,
  }),
  { fetchStores, deleteStore: deleteStoreById, createStoreInfo, updateStoreInfo }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(ManageStores);
